var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { Link } from 'react-router-dom';
import { Styled } from './style';
var Logo = /** @class */ (function (_super) {
    __extends(Logo, _super);
    function Logo(props) {
        return _super.call(this, props) || this;
    }
    Logo.prototype.render = function () {
        var logo = (React.createElement("span", { className: "logo-wrapper" },
            React.createElement("span", { className: "glyph" }),
            this.props.custom && this.props.custom.wordmark
                ?
                    React.createElement("span", { className: "custom-wordmark" }, this.props.custom.wordmark)
                : React.createElement("span", { className: "wordmark", title: (this.props.custom && this.props.custom.title) || 'ScreenCloud' })));
        return (React.createElement(Styled, { className: this.props.className, dark: this.props.dark, glyph: this.props.custom && this.props.custom.glyph, wordmark: this.props.custom && this.props.custom.wordmark, wordmarkColor: this.props.custom && this.props.custom.wordmarkColor }, this.props.url ? React.createElement(Link, { to: this.props.url }, logo) : logo));
    };
    return Logo;
}(React.Component));
export default Logo;
//# sourceMappingURL=index.js.map